<template>
  <div class="bg1" ref="setH" style="padding-left: 10px">
    <div class="search1">
      <el-button
        type="primary"
        @click="
          dialogVisible = true;
          typeSort = 0;
          typeName = '';
        "
        size="small"
        style="float: right"
        >新增资源类别</el-button
      >
    </div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="typeName" label="类别名称"> </el-table-column>
      <el-table-column prop="typeSort" label="排序" width="180">
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click="
              (v) => {
                dialogVisible1 = true;
                typeName = scope.row.typeName;
                typeSort = scope.row.typeSort;
                id = scope.row.id;
              }
            "
            size="small"
            >修改</el-button
          >
          <el-button type="danger" @click="del(scope.row)" size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增资源类别" :visible.sync="dialogVisible" width="30%">
      <div class="search">
        <em>类别名称</em
        ><el-input
          v-model="typeName"
          placeholder="请输入内容"
          size="small"
        ></el-input>
      </div>
      <div class="search">
        <em>排序</em
        ><el-input-number
          v-model="typeSort"
          :min="0"
          label="描述文字"
          size="small"
        ></el-input-number>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="add()" size="small">添 加</el-button>
      </span> </el-dialog
    ><el-dialog title="修改资源类别" :visible.sync="dialogVisible1" width="30%">
      <div class="search">
        <em>类别名称</em
        ><el-input
          v-model="typeName"
          placeholder="请输入内容"
          size="small"
        ></el-input>
      </div>
      <div class="search">
        <em>排序</em
        ><el-input-number
          v-model="typeSort"
          :min="0"
          label="描述文字"
          size="small"
        ></el-input-number>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="modify()" size="small"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogVisible1: false,
      typeName: "",
      typeSort: 0,
      id: "",
      tabH:0,
    };
  },
  mounted() {
    this.$nextTick(()=>{
      this.tabH = this.$refs.setH.clientHeight-80;
    })
    this.getData();
  },
  methods: {
    del(v) {
      this.$confirm("是否删除资源类别 “" + v.typeName + "”?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax
            .post("/server/resource/type/deleteResourceType", {
              id: v.id,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getData();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    modify(v) {
      this.$ajax
        .post("/server/resource/type/editResourceType", {
          typeName: this.typeName,
          typeSort: this.typeSort,
          id: this.id,
        })
        .then((res) => {
          this.dialogVisible1 = false;
          this.getData();
        });
    },
    add() {
      this.$ajax
        .post("/server/resource/type/saveResourceType", {
          typeName: this.typeName,
          typeSort: this.typeSort,
        })
        .then((res) => {
          this.dialogVisible = false;
          this.getData();
        });
    },
    getData() {
      this.$ajax
        .post("/server/resource/type/getResourceTypeList")
        .then((res) => {
          this.tableData = res;
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/manage/category.vue